export default "__VITE_ASSET__cdf7adf4__"